import {Component} from '@angular/core';
import {Router} from "@angular/router";
import {KeycloakService} from "keycloak-angular";
import { JwtService } from 'src/app/core/services/jwt.service';

@Component({
  selector: 'app-login-success',
  standalone: true,
  imports: [],
  templateUrl: './login-success.component.html',
  styleUrl: './login-success.component.css'
})
export class LoginSuccessComponent {
  constructor(private readonly router: Router, private keycloakService: KeycloakService, private jwtService:JwtService) {
  }

  async ngOnInit() {
    const isLogged = this.keycloakService.isLoggedIn()
    if (isLogged) {
      await this.router.navigate(['/'])
    }
  }
}
